import React, { useContext } from 'react';
import { Route, Switch } from 'react-router';
import { useLocation } from 'react-router-dom';

import { Journal } from '../../../journal/journal';
import { CompanyNews, MarketNews, News } from '../../../news/news';
import { PostCard } from '../../../post_card/post_card';
import { AnalyticsArticles, Articles, InterviewArticles, ReviewArticles } from '../../../articles/articles';
import { Blogs, MarketBlogs, SpecBlogs } from '../../../blogs/blogs';
import { MyBlog } from '../../../my_blog/my_blog';
import {
  CityQuestions,
  CommQuestions,
  CountryQuestions,
  ForeignQuestions,
  HypothecQuestions,
  MarketQuestions,
  Questions,
  SpecQuestions,
} from '../../../questions/questions';
import { PostPreview } from '../../../post_preview/post_preview';
import { AddBlog } from '../../../add_blog/add_blog';
import { RatingTable } from '../../../rating_table/rating_table';
import { AddQuestion } from '../../../add_question/add_question';
import { Unsubscribe } from '../../../unsubscribe/unsubscribe';
import { ApplicationContext } from '../../../../utils/applicationContext';
import { PageReload } from '../../../../components/PageReload';

export const Routes = () => {
  const {
    custom: { isNewDesignEnabled, newDesignSubdomains, subdomain },
  } = useContext(ApplicationContext);
  const { search } = useLocation();
  const qs = new URLSearchParams(search);
  const isCorrectSubdomain = newDesignSubdomains?.length ? newDesignSubdomains.includes(subdomain) : true;

  return (
    <Switch>
      <Route path={`/magazine/`} component={Journal}>
        {isNewDesignEnabled && isCorrectSubdomain && !qs.get('tag') && !qs.get('search') && <PageReload />}
      </Route>
      <Route path={`/novosti/market/`} component={MarketNews} />
      <Route path={`/novosti/company/`} component={CompanyNews} />
      <Route path={`/novosti/`} component={News} />
      <Route path={`/novosti-:id/`} component={PostCard} />
      <Route path={`/stati/interview/`} component={InterviewArticles} />
      <Route path={`/stati/review/`} component={ReviewArticles} />
      <Route path={`/stati/analytics/`} component={AnalyticsArticles} />
      <Route path={`/stati-:id/`} component={PostCard} />
      <Route path={`/stati/`} component={Articles} />
      <Route path={`/blogs/`} component={Blogs} />
      <Route path={`/blogs-specialist/`} component={SpecBlogs} />
      <Route path={`/blogs-tendentsiy-rynka/`} component={MarketBlogs} />
      <Route path={`/moi-blog/`} component={MyBlog} />
      <Route path={`/blogs-:id/`} component={PostCard} />
      <Route path={`/forum-rieltorov/`} component={Questions} />
      <Route path={`/forum-rieltorov-specialist/`} component={SpecQuestions} />
      <Route path={`/forum-rieltorov-tendentsiy-rynka/`} component={MarketQuestions} />
      <Route path={`/forum-rieltorov-gorodskaya-nedvizhimost/`} component={CityQuestions} />
      <Route path={`/forum-rieltorov-kommercheskaya-nedvizhimost/`} component={CommQuestions} />
      <Route path={`/forum-rieltorov-zagorodnaya-nedvizhimost/`} component={CountryQuestions} />
      <Route path={`/forum-rieltorov-zarubezhnaya-nedvizhimost/`} component={ForeignQuestions} />
      <Route path={`/forum-rieltorov-ipoteka/`} component={HypothecQuestions} />
      <Route path={`/forum-rieltorov-:id/`} component={PostCard} />
      <Route path={`/preview`} component={PostPreview} />
      <Route path={`/add-blog/`} component={AddBlog} />
      <Route path={`/content-preview`} component={PostPreview} />
      <Route path={`/reyting-rieltorov/`} component={RatingTable} />
      <Route path={`/add-vopros/`} component={AddQuestion} />
      <Route path={`/unsubscribe-email/`} component={Unsubscribe} />
      <Route path={`/magazine-:path/`} component={Articles} />
    </Switch>
  );
};
